<div class="parent">
  <gen-dynamic-form class="inner-form"
                    [formConfig]="formConfig"
                    (formChange)="onValueChange($event.form, $event.updated)"
                    [submitted]="widgetFormInstanceSubmitted"
                    [formItemFullWidth]="true"
                    [formVertical]="false"
                    [listenToDataChange]="true"
                    [disabled]="widgetDisabledStatus"
                    [mapAllProperties]="true"
                    [additionalSearchValues]="parentForm | async"
                    [popupMode]="widgetConfigPayload?.popupMode">
  </gen-dynamic-form>
  <div *ngIf="olderRevisionSelected" [ngClass]="{'new-version-available-wrapper': widgetConfigPayload.cssClass !== ''}" class="{{widgetConfigPayload.cssClass}}">
    <span [ngClass]="{'icon__ExclamationCircle__warning icon__ExclamationCircle': widgetConfigPayload.cssClass !== ''}"></span>
    <span [ngClass]="{'new-version-available': widgetConfigPayload.cssClass !== ''}" class= "old-revision-selected">New version available</span>
  </div>
</div>
